import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  return (
    <Navbar bg="white" expand="lg" fixed="top" className="shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="/doc/logo.png" 
            alt="Allied Thermal Logo" 
            style={{ 
              height: '35px', 
              width: 'auto',
              marginRight: '8px' 
            }} 
          />
          <span style={{ color: '#dc2626', fontWeight: '700', fontSize: '1.625rem' }}>
            Allied Thermal
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className={location.pathname === '/' ? 'active' : ''}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/services" className={location.pathname === '/services' ? 'active' : ''}>
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/products" className={location.pathname === '/products' ? 'active' : ''}>
              Products
            </Nav.Link>
            <Nav.Link as={Link} to="/company-profile" className={location.pathname === '/company-profile' ? 'active' : ''}>
              Company Profile
            </Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className={location.pathname === '/contact-us' ? 'active' : ''}>
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
